import FormsPage from "@/pages/Forms";
export default function Planning() { return <FormsPage tabId="planning" />; }
